/* eslint-disable no-throw-literal */
import {
  GET_SUPPLIER_PRODUCTS,
  CONSUMABLE_ITEM_IMAGE_UPLOAD,
  GET_CATEGORY_PRODUCTS,
  CONSUMABLE_ITEM_GET,
  CONSUMABLE_ITEM_CREATE,
  CONSUMABLE_ITEM_UPDATE,
  CONSUMABLE_ITEM_SHOW,
  CONSUMABLE_ITEM_DELETE
} from './mutation-types'

export default {
  state: {},
  getters: {},
  actions: {
    async [GET_SUPPLIER_PRODUCTS] ({ dispatch }, params) {
      const res = await dispatch('apiGet', { url: '/master/consumable_items/get_supplier_products', data: {id: params.id} })
      if (res.status !== 200 && res.status !== 204) {
        throw {
          status: res.status
        }
      }
      return res.data
    },
    async [CONSUMABLE_ITEM_IMAGE_UPLOAD] ({ dispatch }, params) {
      const res = await dispatch('apiPatch', { url: '/master/consumable_items/upload_image', data: params.data, loadparams: false })
      if (res.status !== 200 && res.status !== 204) {
        throw {
          status: res.status
        }
      }
      return res.data
    },
    async [GET_CATEGORY_PRODUCTS] ({ dispatch }, params) {
      const res = await dispatch('apiGet', { url: '/master/consumable_items/get_category_products', data: {id: params.id} })
      if (res.status !== 200 && res.status !== 204) {
        throw {
          status: res.status
        }
      }
      return res.data
    },
    async [CONSUMABLE_ITEM_GET] ({ dispatch }, params = {}) {
      const res = await dispatch('apiGet', { url: '/master/consumable_items', data: params })
      if (res.status !== 200 && res.status !== 204) {
        throw {
          status: res.status
        }
      }
      return res.data
    },
    async [CONSUMABLE_ITEM_CREATE] ({ dispatch }, params) {
      const res = await dispatch('apiPost', { url: '/master/consumable_items', data: params.data })
      if (res.status !== 200 && res.status !== 204) {
        throw {
          status: res.status
        }
      }
      return res.data
    },
    async [CONSUMABLE_ITEM_UPDATE] ({ dispatch }, params) {
      const res = await dispatch('apiPatch', { url: '/master/consumable_items/' + `${params.data.get('id')}`, data: params.data })
      if (res.status !== 200 && res.status !== 204) {
        throw {
          status: res.status
        }
      }
      return res.data
    },
    async [CONSUMABLE_ITEM_SHOW] ({ dispatch }, params = {}) {
      const res = await dispatch('apiGet', {url: '/master/consumable_items/' + `${params.id}`})
      if (res.status !== 200 && res.status !== 204) {
        throw {
          status: res.status
        }
      }
      return res.data
    },
    async [CONSUMABLE_ITEM_DELETE] ({ dispatch }, params) {
      const res = await dispatch('apiDelete', {url: '/master/consumable_items/' + `${params.id}`})
      if (res.status !== 204) {
        throw {
          status: res.status
        }
      }
    }
  },
  mutations: {}
}



// WEBPACK FOOTER //
// ./src/store/modules/consumable-items.js